import React from "react";

export const Team = ({ data }) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Team</h2>
          <p>
            We are a software developer team eager to help other fellow
            developers like us!
          </p>
        </div>

        <div id="row" className="text-center">
          {data
            ? data.map((member, index) => (
                <div key={index} className="col-md-6 col-sm-6">
                  <div className="thumbnail no-image-card">
                    <div className="caption">
                      <h4>{member.name}</h4>
                      <p className="text-muted">{member.job}</p>
                      <blockquote>
                        <small>{member.quote}</small>
                      </blockquote>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
